import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import Swal from "sweetalert2";
import getToken from "../functions/getToken";
import baseUrl from "../modules/utility/baseUrl";
import LoadingButton from "./loading/LoadingButton";

function ExcelDownload({
  params,
  url = "",
  className = "btn-success",
  ...props
}) {
  const token = getToken();

  const { mutate, isPending } = useMutation({
    mutationKey: ["factor-pdf"],
    mutationFn: () =>
      axios
        .get(baseUrl + url, {
          params,
          headers: {
            Authorization: "Bearer " + token,
          },
          responseType: "blob",
        })
        .then(res => res.data),

    onSuccess: data => {
      const href = URL.createObjectURL(data);

      const link = document.createElement("a");
      link.href = href;

      const date = new Date();
      const time = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ].join("");

      link.setAttribute("download", "file_" + time);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },

    onError: async error => {
      let message = "";

      try {
        const object = JSON.parse(await error.response.data.text());
        message = object.message;
      } catch (error) {
        message = "در ارتباط با سرور با خطا مواجه شدیم";
      }

      Swal.fire({
        icon: "error",
        text: message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "red",
      });
    },
  });

  if (isPending) {
    return <LoadingButton className={className} title="در حال دانلود" />;
  }

  return (
    <button
      type="button"
      onClick={mutate}
      className={"btn" + (className ? " " + className : "")}
      {...props}
    >
      {props.children ?? "دانلود فایل اکسل"}
    </button>
  );
}

export default ExcelDownload;
